import { computed }            from 'mobx';
import appStore                from '../../store/AppStore';
import LsdApiModel             from '../global/LsdApiModel';
import ProjectPoleModel        from '../ProjectPoleModel';
import ProjectCategoryModel    from '../ProjectCategoryModel';
import ProjectSubCategoryModel from '../ProjectSubCategoryModel';

export default class BudgetModel extends LsdApiModel {
	@computed
	public get budgetToValidateAmount() {
		return parseFloat(this.get('budgetToValidate.amount', '0'));
	}

	@computed
	public get budgetToValidateNbItems() {
		return this.get('budgetToValidate.nbItems', 0);
	}

	@computed
	public get budgetValidatedAmount() {
		return parseFloat(this.get('budgetValidated.amount', '0'));
	}

	@computed
	public get budgetValidatedNbItems() {
		return this.get('budgetValidated.nbItems', 0);
	}

	@computed
	public get budgetPaidAmount() {
		return parseFloat(this.get('budgetPaid.amount', '0'));
	}

	@computed
	public get budgetPaidNbItems() {
		return this.get('budgetPaid.nbItems', 0);
	}

	@computed
	public get budgetToPayAmount() {
		return parseFloat(this.get('budgetToPay.amount', 0));
	}

	@computed
	public get budgetToPayNbItems() {
		return this.get('budgetToPay.nbItems', 0);
	}

	@computed
	public get estimatedBudget(): number {
		return this.budgetToValidateAmount; // fake fix to fix api errors I think
	}

	@computed
	public get nbItemsEstimatedBudget(): number {
		return this.budgetToValidateNbItems + this.budgetValidatedNbItems;
	}

	@computed
	public get realBudget(): number {
		return this.budgetToPayAmount + this.budgetPaidAmount;
	}

	@computed
	public get nbItemsRealBudget(): number {
		return this.budgetToPayNbItems + this.budgetPaidNbItems;
	}

	@computed
	public get targetBudget(): number | null {
		return this.getTargetBudget(appStore.currentExpenseGroupId);
	}

	@computed
	public get isExceededBudgetTarget(): boolean {
		return this.estimatedBudget > this.targetBudget;
	}

	@computed
	public get isExceededBudgetTargetReal(): boolean {
		return this.realBudget > this.targetBudget;
	}

	@computed
	public get defaultModel(): LsdApiModel | null {
		const dictionary = {
			ProjectPole: ProjectPoleModel,
			ProjectCategory: ProjectCategoryModel,
			ProjectSubCategory: ProjectSubCategoryModel
		};

		if (dictionary[this.get('@type')]) {
			return new dictionary[this.get('@type')]({ id: this.id });
		}

		return null;
	}

	public getTargetBudget(expenseGroupId: number): number | null {
		// project has is own budget target, for others it's a mix of subCategories budget targets
		return this.get('budgetTarget') || this.get(`budgetTargets.${expenseGroupId}.amount`);
	}
}
